import React, { FC ,useState,useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { Button, Space, Spin } from 'antd'
import PageBreadcrumb from '@/components/pageBreadcrumb'
import { useTranslation } from 'react-i18next'
import { IAppState } from '@/store/reducers'
import * as go from 'gojs'
import { ReactDiagram } from 'gojs-react'
import diagramData from '@/helpers/techRelativeData.json'
import { getAllTechnicalAnalysis } from '@/services/table.service'
import { getBUList, getProdList } from '@/services/progress.service'
import { IProjectInfoResData, ITechYearQuarters } from '@/store/models/tableEdit.model'
import Table2SearchPop from '@/pages/table2Mana/components/table2GlobalSearchPop'
import { DrawerShowContext } from '@/pages/table2SearchAll'
import { SearchOutlined } from '@ant-design/icons'
import { hideLoading, showLoading } from '@/utils/util'
import Nav from '@/components/nav'

class SankeyLayout extends go.LayeredDigraphLayout {
    makeNetwork(coll: any) {
        const net = super.makeNetwork(coll)
        this.diagram?.nodes.each(node => {
        // figure out how tall the node's bar should be
            const height = this.getAutoHeightForNode(node)
            const shape = node.findObject('SHAPE')
            if (shape) shape.height = height
            const text: any = node.findObject('TEXT')
            const ltext: any = node.findObject('LTEXT')
            const font = 'bold ' + Math.max(12, Math.round(height / 8)) + 'pt Segoe UI, sans-serif'
            if (text) text.font = font
            if (ltext) ltext.font = font
            // and update the vertex's dimensions accordingly
            const v = net.findVertex(node)
            if (v !== null) {
                node.ensureBounds()
                const r = node.actualBounds
                v.width = r.width
                v.height = r.height
                v.focusY = v.height / 2
            }
        })
        return net
    }

    getAutoHeightForNode(node: any) {
        let heightIn = 0
        let it = node.findLinksInto()
        while (it.next()) {
            const link = it.value
            heightIn += link.computeThickness()
        }
        let heightOut = 0
        it = node.findLinksOutOf()
        while (it.next()) {
            const link = it.value
            heightOut += link.computeThickness()
        }
        let h = Math.max(heightIn, heightOut)
        if (h < 10) h = 10
        return h
    }

    nodeMinColumnSpace(v: any, topleft: any) {
        if (v.node === null) {
            if (v.edgesCount >= 1) {
                let max = 1
                const it = v.edges
                while (it.next()) {
                    const edge = it.value
                    if (edge.link != null) {
                        const t = edge.link.computeThickness()
                        if (t > max) max = t
                        break
                    }
                }
                return Math.max(2, Math.ceil(max / this.columnSpacing))
            }
            return 2
        }
        return super.nodeMinColumnSpace(v, topleft)
    }

    nodeMinLayerSpace(v: any, topleft: any) {
        if (v.node === null) return 100
        return super.nodeMinLayerSpace(v, topleft)
    }

    assignLayers() {
        super.assignLayers()
        const maxlayer = this.maxLayer
        // now make sure every vertex with no outputs is maxlayer
        for (let it = (this as any).network.vertexes.iterator; it.next();) {
            const v: any = it.value
            // const node = v.node
            // console.log('node: ', node?.data)
            if (v.destinationVertexes.count == 0) {
                v.layer = 0
            }
            if (v.sourceVertexes.count == 0) {
                v.layer = maxlayer
            }
        }
    }

    commitLayout() {
        super.commitLayout()
        for (let it = (this as any).network.edges.iterator; it.next();) {
            const link = it.value.link
            if (link && link.curve === go.Link.Bezier) {
                // depend on Link.adjusting === go.Link.End to fix up the end points of the links
                // without losing the intermediate points of the route as determined by LayeredDigraphLayout
                link.invalidateRoute()
            }
        }
    }
}

/*
    * 参数说明：
    * number：要格式化的数字
    * decimals：保留几位小数
    * dec_point：小数点符号
    * thousands_sep：千分位符号
*/
function number_format(number:any, decimals:any, dec_point:any, thousands_sep:any) {
    number = (number + '').replace(/[^0-9±Ee.]/g, '')
    const n = !isFinite(+number) ? 0 : +number,
        prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
        sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
        dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
        // s = '',
        toFixedFix = function (n:any, prec:any) {
            const k = Math.pow(10, prec)
            return '' + Math.floor(n * k) / k
        }
    const s = (prec ? toFixedFix(n, prec) : '' + Math.floor(n)).split('.')
    const re = /(-?\d+)(\d{3})/
    //console.log(s)
    while (re.test(s[0])) {
        s[0] = s[0].replace(re, '$1' + sep + '$2')
        if ((s[1] || '').length < prec) {
            s[1] = s[1] || ''
            s[1] += new Array(prec - s[1].length + 1).join('0')
        }
    }
    return s.join(dec)
}

const TechRelative: FC = () => {
    const dispatch = useDispatch()
    const history: any = useHistory()
    const { t } = useTranslation()

    const techClassification = useSelector((state: IAppState) => state.tableEditData.techClassification)
    const route = useSelector((state: IAppState) => state.router)

    const [goObj, setGoObj] = useState<any>(null)
    const [topicList, setTopicList] = useState<any[]>([])
    const [nodeDataArray, setNodeDataArray] = useState<any[]>([])
    const [linkDataArray, setLinkDataArray] = useState<any[]>([])
    const [classArr, setClassArr] = useState<any[]>([])
    const [prodList, setProdList] = useState<any[]>([])
    const [buList, setBuList] = useState<any[]>([])
    // 高级搜索
    const [showSearchPop, setShowSearchPop] = useState(false)
    const [searchObj, setSearchObj] = useState<any>({})

    function format(number:any) {
        const value = number_format(number,0,'.',',')
        return value
    }
    
    const workgroupList = useSelector((state: IAppState) => state.tableEditData.workgroupList)
    const colorList = ['#2dc3d2','#40a840','#fec184','#9d75c2','#a1e194','#f6bcd5','#681313','#3483ba','#c9b7d8','#fea19f','#d93c3c','#a6dce6','#c9a59d','#6f3a5f']
    
    function initDiagram() {
        const $ = go.GraphObject.make  // for conciseness in defining templates
      
        const myDiagram =
            $(go.Diagram, {
                initialAutoScale: go.Diagram.UniformToFill,
                'animationManager.isEnabled': false,
                layout: $(SankeyLayout,
                    {
                        setsPortSpots: false,  // to allow the "Side" spots on the nodes to take effect
                        direction: 0,  // rightwards
                        layeringOption: go.LayeredDigraphLayout.LayerLongestPathSink, //LayerLongestPathSink,LayerLongestPathSource,LayerOptimalLinkLength
                        // packOption: go.LayeredDigraphLayout.PackStraighten || go.LayeredDigraphLayout.PackMedian,
                        packOption: go.LayeredDigraphLayout.PackNone,
                        layerSpacing: 50,  // lots of space between layers, for nicer thick links
                        columnSpacing: 10
                    }
                )
            })
        
        // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
        const colors = ['#AC193D/#BF1E4B', '#2672EC/#2E8DEF', '#8C0095/#A700AE', '#5133AB/#643EBF', '#008299/#00A0B1', '#D24726/#DC572E', '#008A00/#00A600', '#094AB2/#0A5BC4']

        // this function provides a common style for the TextBlocks
        function textStyle() {
            return { font: 'bold 12pt Segoe UI, sans-serif', stroke: 'black', margin: 5 }
        }
      
        // define the Node template
        myDiagram.nodeTemplate =
            $(go.Node, go.Panel.Horizontal,
                {
                    locationObjectName: 'SHAPE',
                    locationSpot: go.Spot.Left,
                    portSpreading: go.Node.SpreadingPacked  // rather than the default go.Node.SpreadingEvenly
                },
                $(go.TextBlock, textStyle(),
                    { name: 'LTEXT' },
                    new go.Binding('text', 'ltext')),
                $(go.Shape,
                    {
                        name: 'SHAPE',
                        fill: '#2E8DEF',  // default fill color
                        strokeWidth: 0,
                        portId: '',
                        fromSpot: go.Spot.RightSide,
                        toSpot: go.Spot.LeftSide,
                        height: 10,
                        width: 20
                    },
                    new go.Binding('fill', 'color')),
                $(go.TextBlock, textStyle(),
                    { name: 'TEXT' },
                    new go.Binding('text'))
            )
      
        function getAutoLinkColor(data: any) {
            const nodedata: any = myDiagram.model.findNodeDataForKey(data.from)
            const hex = nodedata.color
            if (hex.charAt(0) == '#') {
                const rgb = parseInt(hex.slice(1, 7), 16)
                const r = rgb >> 16
                const g = rgb >> 8 & 0xFF
                const b = rgb & 0xFF
                let alpha = 0.4
                if (data.width <= 2) alpha = 1
                const rgba = 'rgba(' + r + ',' + g + ',' + b + ', ' + alpha + ')'
                return rgba
            }
            return 'rgba(173, 173, 173, 0.25)'
        }
      
        // define the Link template
        const linkSelectionAdornmentTemplate =
            $(go.Adornment, 'Link',
                $(go.Shape,
                    { isPanelMain: true, fill: null, stroke: 'rgba(0, 0, 255, 0.3)', strokeWidth: 0 })  // use selection object's strokeWidth
            )
      
        myDiagram.linkTemplate =
            $(go.Link, go.Link.Bezier,
                {
                    selectionAdornmentTemplate: linkSelectionAdornmentTemplate,
                    layerName: 'Background',
                    fromEndSegmentLength: 150, toEndSegmentLength: 150,
                    adjusting: go.Link.End
                },
                $(go.Shape, { strokeWidth: 4, stroke: 'rgba(173, 173, 173, 0.25)' },
                    new go.Binding('stroke', '', getAutoLinkColor),
                    new go.Binding('strokeWidth', 'width'))
            )

        myDiagram.model = new go.GraphLinksModel(
            {
                copiesArrays: true,
                copiesArrayObjects: true,
                nodeDataArray: nodeDataArray,
                linkDataArray: linkDataArray,
                linkKeyProperty:'test'
            })
        setGoObj(myDiagram)
        return myDiagram
    }
    const zoomToFit = () => {
        goObj && goObj.commandHandler.zoomToFit()
    }

    // 获取 product list
    const getProductList = async () => {
        const res = await getProdList({
            pageNo: 1,
            pageSize: 10000
        })
        setProdList(res.content)
    }
    // // 获取 bu list
    const getBuListFun = async () => {
        const res = await getBUList()
        setBuList(res)
    }
    async function getTopicList() {
        showLoading(<><Spin size='large' /><span style={{ fontSize: 14, color: '#fff' }}>{t('loading')}</span></>)
        const projectList =  (await getAllTechnicalAnalysis({
            ...searchObj,
            year: searchObj.year ? searchObj.year.join(',') : undefined
        }).finally(() => {
            hideLoading()
        })) as IProjectInfoResData[]
        setTopicList(projectList)
    }

    const routes = [
        {
            path: '/indexPage',
            breadcrumbName: t('indexPage'),
        },
        {
            path: '/',
            breadcrumbName: t('Tech Relative'),
        },
    ]
    useEffect(() => {
        // 获取 product list
        getProductList()
        // // 获取 BU list
        getBuListFun()
        getTopicList()
    }, [])
    useEffect(() => {
        setClassArr([...techClassification])
    }, [techClassification])
    useEffect(() => {
        console.log('searchObj: ', searchObj)
        if (Object.keys(searchObj).length !== 0) {
            getTopicList()
        }
    },[searchObj])
    useEffect(() => {
        const nodeDataArray: React.SetStateAction<any[]> = []
        const linkDataArray: React.SetStateAction<any[]> = []
        let keyIndex = 1
        if(topicList && topicList.length > 0){
            const loadData: { key: string; list: any[] }[] = []
            workgroupList.forEach((w) =>{
                const workList = topicList.filter((item) =>{
                    if (item.techClass.workGroup.id == w.id) {
                        if (searchObj.year && searchObj.year.length > 0) {
                            // 选中年占比
                            let selYearsCount = 0
                            const len = item.techYearQuarters.length
                            item.techYearQuarters.forEach((yearData: ITechYearQuarters) => {
                                if (searchObj.year.indexOf(yearData.year) !== -1) {
                                    selYearsCount++
                                }
                            })
                            item.budgeting = item.budgeting * (selYearsCount / len)
                        }
                        return true
                    } else {
                        return false
                    }
                })
                loadData.push({
                    'key':w.groupName,
                    'list':workList
                })
            })
            let allBudgeting = 0
            topicList.forEach(item =>{
                allBudgeting += item.budgeting ? item.budgeting : 0
            })
            const productPlatforms: any[] = []
            const allclsProductPlatforms: any[] = []
            const productPlatformsBus: any[] = []
            const busDiv: any[] = []
            const divBudgeting: any[] = []
            loadData.forEach((item,index)  =>{
                const color = colorList[index]
                let budgeting = 0
                const classbudgeting: any[] = []
                // 技术域内的技术分类
                item.list.forEach((project)  =>{
                    const clsBudgeting = project.budgeting ? project.budgeting : 0
                    const clsName = project.techClass.classificationName
                    let cl_flg = false
                    for(const cl of classbudgeting){
                        if(cl.techClass === clsName){
                            cl_flg = true
                            cl.budgeting += clsBudgeting
                        }
                    }
                    if(!cl_flg){
                        classbudgeting.push({
                            techClass:clsName,
                            budgeting:clsBudgeting
                        })
                    }
                    budgeting += clsBudgeting
                })
                //技术分类
                for(const cl of classbudgeting){
                    const percent = allBudgeting === 0 ? '0%' : (cl.budgeting / allBudgeting * 100).toFixed(2) + '%'
                    const txt = cl.techClass + '\r\n ￥ ' + format(cl.budgeting) + '\r\n ' + percent
                    nodeDataArray.push({ 'key': cl.techClass,'text':txt,  'color':color })
                    // 技术域 ->技术分类
                    linkDataArray.push({ 'key': keyIndex++, 'from':item.key, 'to': cl.techClass })
                   
                    const clsList = item.list.filter(item =>item.techClass.classificationName == cl.techClass)
                    const clsProductPlatforms: any[] = []
                    clsList.forEach(item =>{
                        const budgeting = item.budgeting ? item.budgeting : 0
                        // 预算分摊到平台
                        const realBudgeting = item.platforms.length > 0 ? budgeting / item.platforms.length : budgeting
                        for(const platform of item.platforms){
                            const platformNameFull = platform.productPlatform
                            const platformName = platform.platform
                            // 平台分类
                            let flg = true
                            for(const d of clsProductPlatforms){
                                if(d.platform == platformName){
                                    flg = false
                                    d.budgeting += realBudgeting
                                    continue
                                }
                            }
                            if(flg){
                                clsProductPlatforms.push({
                                    platform:platformName,
                                    budgeting:realBudgeting
                                })
                            }
                            let flgAll = true
                            for(const d of allclsProductPlatforms){
                                if(d.platform == platformName){
                                    flgAll = false
                                    d.budgeting += realBudgeting
                                    continue
                                }
                            }
                            if(flgAll){
                                allclsProductPlatforms.push({
                                    platform:platformName,
                                    budgeting:realBudgeting
                                })
                            }
                            // 平台
                            let flg2 = true
                            for(const d of productPlatforms){
                                if(d.platform == platformNameFull){
                                    flg2 = false
                                    d.budgeting += realBudgeting
                                    continue
                                }
                            }
                            if(flg2){
                                productPlatforms.push({
                                    clsplatform:platformName,
                                    platform:platformNameFull,
                                    budgeting:realBudgeting
                                })
                            }
                            // 预算分摊到BU
                            const buBudgeting = platform.bus.length > 0 ? realBudgeting / platform.bus.length : realBudgeting
                            for(const b of platform.bus){
                                const existData = productPlatformsBus.filter(item =>item.platform == platformNameFull && item.bu === b.bu )
                                // 平台对应BU关系
                                if(existData.length == 0){
                                    productPlatformsBus.push({
                                        platform:platformNameFull,
                                        bu:b.bu
                                    })
                                }
                                // 计算BU预算
                                let buflg = true
                                for(const budata of busDiv){
                                    if(budata.bu == b.bu){
                                        buflg = false 
                                        budata.budgeting += buBudgeting
                                        continue
                                    }
                                }
                                if(buflg){
                                    busDiv.push({
                                        bu:b.bu,
                                        budgeting: buBudgeting
                                    })
                                }
                                //计算div的所有预算
                                let divflg = true
                                for(const d of divBudgeting){
                                    if(d.divName == b.divName){
                                        divflg = false 
                                        d.budgeting += buBudgeting
                                        continue
                                    }
                                }
                                if(divflg){
                                    divBudgeting.push({
                                        divName:b.divName,
                                        budgeting: buBudgeting
                                    })
                                }
                            }
                        }
                    })
                    // 技术分类 -> 产品平台分类
                    // console.log(clsProductPlatforms)
                    for(const p of clsProductPlatforms){
                        linkDataArray.push({ 'key': keyIndex++, 'from': cl.techClass, 'to':p.platform })
                    }
                }
                // 当前域：所有预算总额
                if(item.list && item.list.length > 0){
                    const percent = allBudgeting === 0 ? '0%' : (budgeting / allBudgeting * 100).toFixed(2) + '%'
                    const txt = item.key + '\r\n ￥' + format(budgeting) + '\r\n ' + percent
                    nodeDataArray.push({ 'key':item.key, 'text': txt , 'color':color })
                }
            })
            // 技术分类 -> 产品平台分类
            for(const p of allclsProductPlatforms){
                const percent = allBudgeting === 0 ? '0%' : (p.budgeting / allBudgeting * 100).toFixed(2) + '%'
                const txt = p.platform + '\r\n ￥ ' + format(p.budgeting) + '\r\n ' + percent
                nodeDataArray.push({ 'key': p.platform,'text':txt })
            }
            // 产品平台分类->产品平台
            productPlatforms.forEach((p,index) =>{
                const percent = allBudgeting === 0 ? '0%' : (p.budgeting / allBudgeting * 100).toFixed(2) + '%'
                const txt = p.platform + '\r\n ￥ ' + format(p.budgeting) + '\r\n ' + percent
                nodeDataArray.push({ 'key': 'platform_' +  p.platform,'text':txt,'color':colorList[index] })
                linkDataArray.push({ 'key': keyIndex++, 'from': p.clsplatform, 'to': 'platform_' +  p.platform  })
            })
            // 平台->BU
            busDiv.forEach((budata,index) =>{
                const percent = allBudgeting === 0 ? '0%' : (budata.budgeting / allBudgeting * 100).toFixed(2) + '%'
                const txt = budata.bu + '\r\n ￥ ' + format(budata.budgeting) + '\r\n ' + percent
                // if(budata.bu === 'CT'){
                //     nodeDataArray.push({ 'key': 'bu_' + budata.bu,'text':  txt })
                // }else{
                // }
                nodeDataArray.push({ 'key':'bu_' +  budata.bu,'text': txt,'color':colorList[index] })
            })
            productPlatformsBus.forEach((busData) =>{
                linkDataArray.push({ 'key': keyIndex++, 'from': 'platform_' +  busData.platform, 'to':'bu_' + busData.bu ,'width':10 })
                // if(busData.bu === 'CT'){
                // }else{
                //     linkDataArray.push({ 'key': keyIndex++, 'from':busData.platform, 'to': busData.bu  })
                // }
            })
            divBudgeting.forEach((div,index)=>{
                const percent = allBudgeting === 0 ? '0%' : (div.budgeting / allBudgeting * 100).toFixed(2) + '%'
                const txt = div.divName + '\r\n ￥ ' + format(div.budgeting) + '\r\n ' + percent
                // if(div.divName === 'CT'){
                //     nodeDataArray.push({ 'key': 'div_' + div.divName,'text':txt })
                // }else{
                // }
                nodeDataArray.push({ 'key':'div_' + div.divName,'text':txt,'color':colorList[index] })
            })
            // BU ->DIV
            buList.forEach(item => {
                linkDataArray.push({ 'key': keyIndex++, 'from':'bu_' + item.bu, 'to': 'div_' + item.divName })
                // if(item.divName === 'CT'){
                // }else{
                //     linkDataArray.push({ 'key': keyIndex++, 'from':item.bu, 'to':item.divName })
                // }
            })
            // linkDataArray.push({ 'key': keyIndex++, 'from':'IC_ICI2', 'to':'Div.IC' })
            // linkDataArray.push({ 'key': keyIndex++, 'from':'IC_ICI3', 'to':'Div.IC' })
            // linkDataArray.push({ 'key': keyIndex++, 'from':'IC_BIC', 'to':'Div.IC' })
            // linkDataArray.push({ 'key': keyIndex++, 'from':'IC_ADS', 'to':'Div.IC' })
            // linkDataArray.push({ 'key': keyIndex++, 'from':'ID_IDS', 'to':'Div.ID' })
            // linkDataArray.push({ 'key': keyIndex++, 'from':'ID_IDC', 'to':'Div.ID' })
            // linkDataArray.push({ 'key': keyIndex++, 'from':'ID_ITT', 'to':'Div.ID' })
            // linkDataArray.push({ 'key': keyIndex++, 'from':'CS_IOV', 'to':'Div.CS' })
            // linkDataArray.push({ 'key': keyIndex++, 'from':'bu_CT', 'to':'div_CT' })
        }
        setNodeDataArray(nodeDataArray)
        setLinkDataArray(linkDataArray)
    }, [topicList])
    return (<>
        <Space direction="vertical" size={10} style={{ width: '100%' }}>
            <Nav dispatch={dispatch} />
            <PageBreadcrumb routerParam={routes}
                history={history}
                route={route}
                dispatch={dispatch}
            />
            <Button type='primary'
                icon={<SearchOutlined />}
                onClick={() => {
                    setShowSearchPop(!showSearchPop)
                }}
                style={{ marginLeft: 5 }}
            >{t('filter')}</Button>
            <ReactDiagram
                divClassName={diagramData.class}
                initDiagram={initDiagram}
                nodeDataArray={nodeDataArray}
                linkDataArray={linkDataArray}
            />
            <Space style={{ display: 'flex', justifyContent: 'flex-end', paddingRight: 10, paddingBottom: 10 }}>
                <Button onClick={zoomToFit}>{t('Zoom To Fit')}</Button>
            </Space>
        </Space>
        <DrawerShowContext.Provider value={{ showSearchPop, setShowSearchPop, setSearchObj, classArr, prodList, buList }}>
            <Table2SearchPop />
        </DrawerShowContext.Provider>
    </>)
}
export default TechRelative